import React from 'react'
import Failure from '../Images/APIError.png'
import { useSelector } from 'react-redux';

function Expiry() {
    const { mandateData } = useSelector((state) => state.mandateInfo);
    return (
        <div className="container Payment-way-page mt-5 mb-4">
            <div className="row">
                <div class="col-12 text-center">
                <p className="Pay_way mt-3" style={{wordWrap:"break-word"}}>{mandateData?.Message}</p>
                </div>
            </div>
            <div class="col-12 justify-content-center" style={{ display: "flex" }}>
                <img src={Failure} class="img-fluid" alt="Logo" width={"50%"}/>
            </div>
            
        </div>
    )
}

export default Expiry